const Cargos = () => {
    return (
        <>
            <option value="" selected >Selecione um cargo...</option>
            <option value="ADVOGADO">ADVOGADO</option>
            <option value="AJ DE COZINHA">AJ DE COZINHA</option>
            <option value="AJ.DE PADEIRO">AJ.DE PADEIRO</option>
            <option value="ANALISTA CONTABIL">ANALISTA CONTABIL</option>
            <option value="ANALISTA DE CBM">ANALISTA DE CBM</option>
            <option value="ANALISTA DE ENGENHARIA">ANALISTA DE ENGENHARIA</option>
            <option value="ANALISTA DE ESCRITA FISCAL">ANALISTA DE ESCRITA FISCAL</option>
            <option value="ANALISTA DE INVENTARIO">ANALISTA DE INVENTARIO</option>
            <option value="ANALISTA DE MARKETING">ANALISTA DE MARKETING</option>
            <option value="ANALISTA DE PROCESSOS">ANALISTA DE PROCESSOS</option>
            <option value="ANALISTA DE RH">ANALISTA DE RH</option>
            <option value="ANALISTA FINANCEIRO">ANALISTA FINANCEIRO</option>
            <option value="ANALISTA INTELIGENCIA COMERCIAL">ANALISTA INTELIGENCIA COMERCIAL</option>
            <option value="APRENDIZ EM SERV DE VENDAS">APRENDIZ EM SERV DE VENDAS</option>
            <option value="ARQUITETA">ARQUITETA</option>
            <option value="ASSISTENTE COMERCIAL">ASSISTENTE COMERCIAL</option>
            <option value="ASSISTENTE CONTABIL">ASSISTENTE CONTABIL</option>
            <option value="ASSISTENTE DE ENGENHARIA">ASSISTENTE DE ENGENHARIA</option>
            <option value="ASSISTENTE DEP PESSOAL">ASSISTENTE DEP PESSOAL</option>
            <option value="ASSISTENTE DESIGNER">ASSISTENTE DESIGNER</option>
            <option value="ASSISTENTE FINANCEIRO">ASSISTENTE FINANCEIRO</option>
            <option value="ASSISTENTE FISCAL">ASSISTENTE FISCAL</option>
            <option value="ASSISTENTE JURIDICO">ASSISTENTE JURIDICO</option>
            <option value="ASSISTENTE TI">ASSISTENTE TI</option>
            <option value="ATENDENTE DE LANCHONETE">ATENDENTE DE LANCHONETE</option>
            <option value="ATENDENTE DE SAC">ATENDENTE DE SAC</option>
            <option value="AUX ADM I">AUX ADM I</option>
            <option value="AUX ADMINISTRATIVO">AUX ADMINISTRATIVO</option>
            <option value="AUX CONTABIL">AUX CONTABIL</option>
            <option value="AUX DE ESCRITA FISCAL">AUX DE ESCRITA FISCAL</option>
            <option value="AUX DE FLV">AUX DE FLV</option>
            <option value="AUX DE MONITORAMENTO">AUX DE MONITORAMENTO</option>
            <option value="AUX DE RH">AUX DE RH</option>
            <option value="AUX DEP PESSOAL">AUX DEP PESSOAL</option>
            <option value="AUX FINANCEIRO">AUX FINANCEIRO</option>
            <option value="AUX MECANICO DE EMPILHADEIRA">AUX MECANICO DE EMPILHADEIRA</option>
            <option value="AUX SERV GERAIS">AUX SERV GERAIS</option>
            <option value="AUX TI">AUX TI</option>
            <option value="AUX. DE RECEBIMENTO FISCAL">AUX. DE RECEBIMENTO FISCAL</option>
            <option value="AUXILIAR COMERCIAL">AUXILIAR COMERCIAL</option>
            <option value="AUXILIAR DE ENGENHARIA">AUXILIAR DE ENGENHARIA</option>
            <option value="AUXILIAR DE MARKETING">AUXILIAR DE MARKETING</option>
            <option value="CARTAZISTA">CARTAZISTA</option>
            <option value="CARTAZISTA SENIOR">CARTAZISTA SENIOR</option>
            <option value="COMPRADOR JUNIOR">COMPRADOR JUNIOR</option>
            <option value="CONFERENTE">CONFERENTE</option>
            <option value="CONFERENTE DE INVENTARIO">CONFERENTE DE INVENTARIO</option>
            <option value="CONFERENTE INVENTARIO VOLANTE">CONFERENTE INVENTARIO VOLANTE</option>
            <option value="CONFERENTE VOLANTE">CONFERENTE VOLANTE</option>
            <option value="COORDENADOR CONTABIL">COORDENADOR CONTABIL</option>
            <option value="COORDENADOR DE CONTROLADORIA">COORDENADOR DE CONTROLADORIA</option>
            <option value="COORDENADOR DE DEP. PESSOAL">COORDENADOR DE DEP. PESSOAL</option>
            <option value="COORDENADOR DE INVENTARIO">COORDENADOR DE INVENTARIO</option>
            <option value="COORDENADOR DE MARKETING">COORDENADOR DE MARKETING</option>
            <option value="COORDENADOR FINANCEIRO">COORDENADOR FINANCEIRO</option>
            <option value="COORDENADOR DE TI">COORDENADOR DE TI</option>
            <option value="COORDENADOR FISCAL">COORDENADOR FISCAL</option>
            <option value="COZINHEIRA">COZINHEIRA</option>
            <option value="COZINHEIRO">COZINHEIRO</option>
            <option value="DESIGNER">DESIGNER</option>
            <option value="DIRETOR DE MARKETING">DIRETOR DE MARKETING</option>
            <option value="ENC DE FLV">ENC DE FLV</option>
            <option value="ENC DE MERCEARIA">ENC DE MERCEARIA</option>
            <option value="ENC DE PERECIVEIS">ENC DE PERECIVEIS</option>
            <option value="ENC DE PREVENCAO DE PERDAS">ENC DE PREVENCAO DE PERDAS</option>
            <option value="ENC DE RECEBIMENTO">ENC DE RECEBIMENTO</option>
            <option value="ENC FRENTE DE LOJA">ENC FRENTE DE LOJA</option>
            <option value="ESPECIALISTA DE REMUNERAÇÃO E BENEFÍCIOS">ESPECIALISTA DE REMUNERAÇÃO E BENEFÍCIOS</option>
            <option value="ESPECIALISTA DE TRADE MARKETING">ESPECIALISTA DE TRADE MARKETING</option>
            <option value="ESPECIALISTA TREINAMENTO E DESENVOLVIMENTO">ESPECIALISTA TREINAMENTO E DESENVOLVIMENTO</option>
            <option value="FISCAL DE CAIXA">FISCAL DE CAIXA</option>
            <option value="GERENTE CONTABIL">GERENTE CONTABIL</option>
            <option value="GERENTE COMERCIAL">GERENTE COMERCIAL</option>
            <option value="GERENTE DE DP">GERENTE DE DP</option>
            <option value="GERENTE DE MARKETING">GERENTE DE MARKETING</option>
            <option value="GERENTE DE PATRIMONIO">GERENTE DE PATRIMONIO</option>
            <option value="GERENTE DE RH">GERENTE DE RH</option>
            <option value="GERENTE DE RISCOS">GERENTE DE RISCOS</option>
            <option value="GERENTE DE TI">GERENTE DE TI</option>
            <option value="GERENTE FINANCEIRO">GERENTE FINANCEIRO</option>
            <option value="GERENTE DE LOJA">GERENTE DE LOJA</option>
            <option value="GERENTE TRAINEE">GERENTE TRAINEE</option>
            <option value="GESTOR DE COMPRAS">GESTOR DE COMPRAS</option>
            <option value="GESTOR DE COMPRAS JUNIOR">GESTOR DE COMPRAS JUNIOR</option>
            <option value="LOCUTOR">LOCUTOR</option>
            <option value="LOCUTOR SENIOR">LOCUTOR SENIOR</option>
            <option value="MECANICO DE EMPILHADEIRA">MECANICO DE EMPILHADEIRA</option>
            <option value="MOTORISTA AUXILIAR">MOTORISTA AUXILIAR</option>
            <option value="MOTORISTA DE CAMINHAO">MOTORISTA DE CAMINHAO</option>
            <option value="NUTRICIONISTA">NUTRICIONISTA</option>
            <option value="OP DE CAIXA">OP DE CAIXA</option>
            <option value="OP DE EMPILHADEIRA">OP DE EMPILHADEIRA</option>
            <option value="OP DE ESTACIONAMENTO">OP DE ESTACIONAMENTO</option>
            <option value="OP DE FLV">OP DE FLV</option>
            <option value="OP DE LOJA (ESTOQUE)">OP DE LOJA (ESTOQUE)</option>
            <option value="OP DE LOJA (FLV)">OP DE LOJA (FLV)</option>
            <option value="OP DE LOJA (FRENTE DE LOJA)">OP DE LOJA (FRENTE DE LOJA)</option>
            <option value="OP DE LOJA (MERCEARIA)">OP DE LOJA (MERCEARIA)</option>
            <option value="OP DE LOJA (PERECIVEIS)">OP DE LOJA (PERECIVEIS)</option>
            <option value="OP DE PERECIVEIS">OP DE PERECIVEIS</option>
            <option value="OP DE PREV DE PERDAS">OP DE PREV DE PERDAS</option>
            <option value="OP DE TELEVENDAS">OP DE TELEVENDAS</option>
            <option value="OP DE TELEVENDAS VOLANTE">OP DE TELEVENDAS VOLANTE</option>
            <option value="PEDREIRO">PEDREIRO</option>
            <option value="PROMOTOR DE VINHOS E DESTILADO">PROMOTOR DE VINHOS E DESTILADO</option>
            <option value="RECEPCIONISTA">RECEPCIONISTA</option>
            <option value="SECRETARIA">SECRETARIA</option>
            <option value="SEPARADOR DE COLETA">SEPARADOR DE COLETA</option>
            <option value="SERVENTE DE OBRAS">SERVENTE DE OBRAS</option>
            <option value="SOCIO DIRETOR">SOCIO DIRETOR</option>
            <option value="SUBGERENTE I">SUBGERENTE I</option>
            <option value="SUPERVISOR DE FLV">SUPERVISOR DE FLV</option>
            <option value="SUPERVISOR DE MANUTENCAO">SUPERVISOR DE MANUTENCAO</option>
            <option value="SUPERVISOR DE MERCEARIA">SUPERVISOR DE MERCEARIA</option>
            <option value="SUPERVISOR DE PERECIVEIS">SUPERVISOR DE PERECIVEIS</option>
            <option value="SUPERVISOR DE PREV DE PERDAS">SUPERVISOR DE PREV DE PERDAS</option>
            <option value="SUPERVISOR DE RECEBIMENTO">SUPERVISOR DE RECEBIMENTO</option>
            <option value="SUPERVISOR DE REFRIGERAÇÃO">SUPERVISOR DE REFRIGERAÇÃO</option>
            <option value="SUPERVISOR DE TELEVENDAS">SUPERVISOR DE TELEVENDAS</option>
            <option value="TECNICO DE MANUTENCAO">TECNICO DE MANUTENCAO</option>
            <option value="TECNICO REFRIGERAÇÃO">TECNICO REFRIGERAÇÃO</option>
            <option value="TECNICO SEGURANCA TRABALHO">TECNICO SEGURANCA TRABALHO</option>
        </>
    );
}

export default Cargos;